"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const Cell_1 = require("../components/Cell");
const Row_1 = require("../components/Row");
const consts_1 = require("../consts");
const useSchedule_1 = require("../useSchedule");
const Body = (0, styled_1.default)(elements_1.Clickable)({
    display: 'flex',
    color: constants_1.Color.MEDIUM_BLUE,
    height: '100%',
    justifyContent: 'center',
    background: constants_1.Color.WHITE,
    ':hover': {
        background: constants_1.Color.LIGHTER_BLUE,
    },
    fontWeight: 700,
    zIndex: consts_1.composableZIndex.newShiftRow,
    transition: 'background 0.2s ease-in-out',
    position: 'sticky',
    left: 0,
    gap: constants_1.theme.spacing[2],
});
const Button = (props) => {
    const { enableEditing, columnCount, containerWidth } = (0, useSchedule_1.useSchedule)();
    if (!props.permanent && !enableEditing)
        return null;
    if (!containerWidth)
        return null;
    return ((0, jsx_runtime_1.jsx)(Row_1.Row, { children: (0, jsx_runtime_1.jsx)(Cell_1.Cell, { style: { padding: 0 }, colSpan: columnCount, children: (0, jsx_runtime_1.jsxs)(Body, { styles: { width: containerWidth }, onClick: () => props.onClick(), hoverBackgroundColor: constants_1.Color.LIGHTEST_BLUE, children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { py: 2, children: props.label }), props.icon && (0, jsx_runtime_1.jsx)(elements_1.Icon, { size: "sm", name: props.icon })] }) }) }));
};
exports.Button = Button;
